<div class="bufr-container">
  <!-- Render each item in the repeated array -->
  <div
    class="bufr-item"
    *ngFor="let f of field.fieldGroup; let i = index; trackBy: trackByIndex">   
    <span>&nbsp;</span>
    <!-- Render the inner fields for the i-th item -->
    <formly-field [field]="f"></formly-field>

    <!-- Per-item actions (Remove button) -->
    <div class= "align-change">
      <button
        type="button"
        class="btn btn-light btn-size"
        (click)="remove(i)"
        [disabled]="to?.disableRemove === true"
      >Remove Change</button>
      <div class="change-separator">
        <hr>
      </div>
    </div>
  </div>
  <!-- Global Add button -->
  <div class= "bufr-item align-change">
    <br>
    <button
      type="button"
      class="btn btn-light btn-size"
      (click)="add()"
    >Create Change
    </button>
  </div>
</div>